import { minimumCompanyDataSchemaDE } from '../../CompanyDetails/CompanyDetailsDE/CompanyDetailsDE.schema';
import { minimumCompanyDataSchema } from '../../CompanyDetails/CompanyDetailsUK/CompanyDetailsUK.schema';
import { minimumPersonalDataSchemaDE } from '../../PersonalDetails/PersonalDetailsDE/PersonalDetailsDE.schema';
import { minimumPersonalDataSchema } from '../../PersonalDetails/PersonalDetailsUK/PersonalDetailsUK.schema';

export const createValidatorFromYupSchema = (
  validator:
    | typeof minimumCompanyDataSchema
    | typeof minimumPersonalDataSchema
    | typeof minimumCompanyDataSchemaDE
    | typeof minimumPersonalDataSchemaDE,
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (data: any) => {
    try {
      validator.validateSync(data);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      return false;
    }
    return true;
  };
};
